<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, watch, inject } from "vue";
import Swal from "sweetalert2";
import { router, useForm, usePage } from "@inertiajs/vue3";
const route = inject('route');

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  jenis: {
    type: Object,
    required: true,
  },
  program: {
    type: Object,
    required: true,
  },
  instrumen: {
    type: Object,
    required: true,
  },
});

const form = useForm({
  id: null,
  instid: "",
  nama_dok: "",
  jenis_dok: "",
  prodi: "",
  status: "",
  deskripsi: "",
  files: [],
});

watch(
  () => props.instrumen,
  (newValue) => {
    if (newValue && newValue.data && newValue.data.length > 0) {
      const firstItem = newValue.data[0];
      form.instid = firstItem.id;
      form.jenis_dok = firstItem.jenis_id;
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => props.program,
  (newValue) => {
    if (newValue) {
      form.prodi = newValue.id;
    }
  },
  { immediate: true }
);

function handleFileChange(e) {
  form.files = Array.from(e.target.files);
}
const fileInput = ref(null);

const submit = async () => {
  const formData = new FormData();
  formData.append("instid", form.instid);
  formData.append("nama_dok", form.nama_dok);
  formData.append("jenis_dok", form.jenis_dok);
  formData.append("prodi", form.prodi);
  formData.append("status", form.status);
  formData.append("deskripsi", form.deskripsi);
  form.files.forEach((file, index) => {
    formData.append(`files[${index}]`, file);
  });

  try {
    const response = await axios.post(route("kinerja.store"), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.success) {
      Swal.fire({
        title: "Berhasil!",
        text: response.data.message,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        const slugid = props.instrumen.data[0].slugid;
        router.reload(route("kinerja.adddocument", { id: slugid }), {
          preserveState: true,
          preserveScroll: true,
        });
        form.reset();
        form.files = [];
        if (fileInput.value) {
          fileInput.value.value = ""; // Reset elemen input file di DOM
        }
      });
    }
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    Swal.fire({
      title: "Gagal!",
      text: "Info: " + error.response?.data.message || "Terjadi kesalahan",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};
</script>
<template>
  <div class="items-center justify-center p-4 bg-opacity-50 rounded-lg shadow-md border-bg-gray-200">
    <form class="space-y-4" @submit.prevent="submit">
      <div>
        <InputField label="Nama Dokumen" icon="pen" v-model.trim="form.nama_dok" />
        <InputError :message="form.errors.nama_dok" class="mt-2" />
      </div>

      <!-- Deskripsi -->
      <div>
        <label for="Deskripsi" class="block text-sm font-medium text-gray-700">Deskripsi</label>
        <textarea
          class="w-full p-2 mt-1 text-sm border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="Deskripsi" rows="4" v-model="form.deskripsi"></textarea>
        <InputError :message="form.errors.deskripsi" class="mt-2" />
      </div>

      <!-- Jenis Dokumen -->
      <div v-if="$page.props.auth.user.kodeprodi === null">
        <label for="programstudi" class="block text-sm font-medium text-gray-700">Program Studi</label>
        <select v-model="form.prodi"
          class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500">
          <option value="">Pilih Prodi</option>
          <option v-for="prod in program.data" :key="prod.id" :value="prod.id">
            {{ prod.jenjang }} - {{ prod.name }}
          </option>
        </select>
        <InputError :message="form.errors.jenis_dok" class="mt-2" />
      </div>
      <!-- Kategori -->
      <div>
        <label for="Kategori" class="block text-sm font-medium text-gray-700">Kategori</label>
        <select v-model="form.status"
          class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500">
          <option value="">Pilih Kategori</option>
          <option value="0">Eksternal</option>
          <option value="1">Internal</option>
        </select>
        <InputError :message="form.errors.status" class="mt-2" />
      </div>

      <!-- File Upload -->
      <div>
        <InputLabel for="gambar" value="File" class="block text-sm font-medium text-gray-700" />
        <input type="file" ref="fileInput" multiple @change="handleFileChange"
          class="block w-full mt-1 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:ring-indigo-500 focus:border-indigo-500" />
        <progress v-if="form.progress" :value="form.progress.percentage" max="100" class="w-full mt-2">
          {{ form.progress.percentage }}%
        </progress>
        <InputError :message="form.errors.file_path" class="mt-2" />
      </div>

      <!-- Submit Button -->
      <div class="mt-6">
        <PrimaryBtn type="submit" class="w-full"> Simpan Dokumen </PrimaryBtn>
      </div>
    </form>
  </div>
</template>
